module.exports = __webpack_public_path__ + "img/step.3eae4f60.svg";